// 基礎力レベル日報時のエンティティ
export class BasicStrengthDaily {
  // 授業ID DB型(*autokeyFk)
  public class_id?: number;
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 基礎力項目 DB型(*varchar20)
  public strength_item?: string;
  // 達成 DB型(*flg)
  public is_done?: boolean;
  // レベル DB型(INT)
  public current_level?: number;
  // スコア DB型(INT)
  public score?: number;
  // エピソード DB型(*varchar1024)
  public episode?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): BasicStrengthDaily {
    const entity = new BasicStrengthDaily();
    entity.class_id = record['class_id'];
    entity.user_id = record['user_id'];
    entity.strength_item = record['strength_item'];
    entity.is_done = record['is_done'];
    entity.current_level = record['current_level'];
    entity.score = record['score'];
    entity.episode = record['episode'];
    return entity;
  }
  static getTypeFitEntity(value: any): BasicStrengthDaily {
    const entity = new BasicStrengthDaily();
    entity.class_id = value.class_id;
    entity.user_id = value.user_id;
    entity.strength_item = value.strength_item;
    entity.is_done = value.is_done;
    entity.current_level = value.current_level;
    entity.score = value.score;
    entity.episode = value.episode;
    return entity;
  }
}
